import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import EmbedGenerator from "@/pages/EmbedGenerator";

export const Route = createFileRoute("/embed/generator")({
  head: () => seoHead("/embed/generator"),
  component: EmbedGenerator,
});
